"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreUtils = void 0;
const unit_1 = require("@keplr-wallet/unit");
class StoreUtils {
    static getBalancesFromCurrencies(currenciesMap, bals) {
        const result = [];
        for (const bal of bals) {
            const currency = currenciesMap[bal.denom];
            if (currency) {
                const amount = new unit_1.Dec(bal.amount);
                if (amount.truncate().gt(new unit_1.Int(0))) {
                    result.push(new unit_1.CoinPretty(currency, amount));
                }
            }
        }
        return result;
    }
    static getBalanceFromCurrency(currency, bals) {
        const result = StoreUtils.getBalancesFromCurrencies({
            [currency.coinMinimalDenom]: currency,
        }, bals);
        if (result.length === 1) {
            return result[0];
        }
        return new unit_1.CoinPretty(currency, new unit_1.Int(0)).ready(false);
    }
}
exports.StoreUtils = StoreUtils;
//# sourceMappingURL=index.js.map